import LegalLayout, { H } from "../../components/LegalLayout";

export default function AvisoLegal() {
  return (
    <LegalLayout title="Aviso Legal" updated="Junio 2026">
      <p>
        El presente aviso legal regula el uso del sitio web de JordyBT_Fitness — Elite Coaching, en cumplimiento de
        la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico
        (LSSI-CE).
      </p>

      <H>1. Titular del sitio web</H>
      <p>
        Titular: Jordi Betoret (JordyBT_Fitness — Elite Coaching). Actividad: asesoramiento en nutrición deportiva,
        entrenamiento y transformación física. Los datos identificativos completos del titular se facilitarán a
        través de los canales de contacto habilitados.
      </p>

      <H>2. Objeto</H>
      <p>
        Este sitio web tiene como finalidad ofrecer información sobre el programa Elite Coaching y permitir a los
        usuarios solicitar una valoración gratuita y reservar una llamada. El acceso y uso de la web atribuye la
        condición de usuario e implica la aceptación de las condiciones recogidas en este aviso legal.
      </p>

      <H>3. Propiedad intelectual e industrial</H>
      <p>
        Todos los contenidos del sitio web (textos, imágenes, fotografías, logotipos, diseño y código) son
        titularidad del responsable o de terceros que han autorizado su uso, y están protegidos por la normativa de
        propiedad intelectual e industrial. Queda prohibida su reproducción, distribución o comunicación pública sin
        autorización expresa.
      </p>

      <H>4. Responsabilidad</H>
      <p>
        El titular no se hace responsable de los daños y perjuicios derivados del uso indebido de la web ni de la
        información contenida en la misma. Los resultados de transformación física mostrados corresponden a clientes
        reales y no constituyen una garantía de resultados, ya que estos dependen del compromiso y las
        circunstancias individuales de cada persona.
      </p>

      <H>5. Legislación aplicable</H>
      <p>
        Las presentes condiciones se rigen por la legislación española. Para la resolución de cualquier controversia,
        las partes se someten a los juzgados y tribunales que correspondan conforme a derecho.
      </p>
    </LegalLayout>
  );
}
